export default function Maillage() {
  const liens = [
    {
      href: "/reparation-volet-roulant",
      title: "Réparation complète de volet roulant",
      desc: "Toutes les pannes de volets roulants : coffre, tablier, motorisation, manivelle, sangle. Un service global à Strasbourg.",
    },
    {
      href: "/tablier-volet-roulant",
      title: "Remplacement de tablier de volet roulant",
      desc: "Si votre tablier est endommagé en même temps que le coffre, nous pouvons remplacer les deux en une seule intervention.",
    },
    {
      href: "/motorisation-somfy",
      title: "Motorisation de volet roulant",
      desc: "Profitez de l'intervention sur coffre pour installer une motorisation neuve et moderniser votre volet roulant.",
    },
  ];

  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <h2 className="text-2xl md:text-3xl font-bold text-brand-blue mb-8">
          Pages connexes
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {liens.map((lien, i) => (
            <a
              key={i}
              href={lien.href}
              className="group bg-brand-light rounded-xl border border-brand-border p-5 hover:border-brand-cyan transition-colors"
            >
              <h3 className="font-semibold text-brand-blue mb-2 group-hover:text-brand-cyan transition-colors text-sm md:text-base">
                {lien.title}
              </h3>
              <p className="text-sm text-brand-text leading-relaxed">{lien.desc}</p>
              <span className="inline-flex items-center gap-1 text-brand-cyan text-sm font-medium mt-3">
                En savoir plus <i className="ri-arrow-right-line"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}